import { render, staticRenderFns } from "./PostCreation_Button_Tag.vue?vue&type=template&id=18aea418&scoped=true&"
import script from "./PostCreation_Button_Tag.vue?vue&type=script&lang=js&"
export * from "./PostCreation_Button_Tag.vue?vue&type=script&lang=js&"
import style0 from "./PostCreation_Button_Tag.vue?vue&type=style&index=0&id=18aea418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18aea418",
  null
  
)

export default component.exports